export const chunk = <T>(arr: T[], size: number = 3) => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (_, index) =>
    arr.slice(index * size, (index + 1) * size)
  );
};
